import { createSlice } from "@reduxjs/toolkit";
import {
  findStaffs,
  getAllSubjects,
  getCollegeSchedule,
  findStudents,
  getJoutnalNotes,
  getStaffsControl,
} from "./api";
import { getJournalOptions } from "pages/teacher/api";

const initialState = {
  findedStaffs: null,
  findStaffsLoading: false,
  findedStudents: null,
  findStudentsLoading: false,
  allSubjects: null,
  getAllSubjectsLoading: false,
  collegeSchedule: null,
  journalNotes: null,
  staffsControlData: null,
  activeClassRoom: null,
};

const directorSlice = createSlice({
  name: "director",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findStaffs.pending, (state, action) => {
      state.findStaffsLoading = true;
    });
    builder.addCase(findStaffs.fulfilled, (state, action) => {
      state.findedStaffs = action.payload;
      state.findStaffsLoading = false;
    });

    builder.addCase(findStaffs.rejected, (state, action) => {
      state.findStaffsLoading = false;
    });

    builder.addCase(findStudents.pending, (state, action) => {
      state.findStudentsLoading = true;
    });
    builder.addCase(findStudents.fulfilled, (state, action) => {
      state.findedStudents = action.payload;
      state.findStudentsLoading = false;
    });

    builder.addCase(findStudents.rejected, (state, action) => {
      state.findStudentsLoading = false;
    });

    builder.addCase(getAllSubjects.pending, (state, action) => {
      state.getAllSubjectsLoading = true;
    });
    builder.addCase(getAllSubjects.fulfilled, (state, action) => {
      state.allSubjects = action.payload;
      state.getAllSubjectsLoading = false;
    });

    builder.addCase(getAllSubjects.rejected, (state, action) => {
      state.getAllSubjectsLoading = false;
    });

    builder.addCase(getCollegeSchedule.fulfilled, (state, action) => {
      state.collegeSchedule = action.payload;
    });

    builder.addCase(getJoutnalNotes.fulfilled, (state, action) => {
      state.journalNotes = action.payload;
    });

    builder.addCase(getStaffsControl.fulfilled, (state, action) => {
      state.staffsControlData = action.payload;
    });

    builder.addCase(getJournalOptions.fulfilled, (state, action) => {
      state.activeClassRoom = action?.payload?.find(
        (el) => el.group_id === +action.meta.arg
      );
    });
  },
});

// export const {} = directorSlice.actions;

export default directorSlice.reducer;
